export const AB_TEST_MW_APP_BANNER_KEY = 'MW_APP_BANNER' as const;
export const APP_BANNER_STORAGE_KEY = 'closedAppBanner' as const;
